import { render, staticRenderFns } from "./CreateDeliveryNote.vue?vue&type=template&id=4ce62884&lang=pug&"
import script from "./CreateDeliveryNote.vue?vue&type=script&lang=ts&"
export * from "./CreateDeliveryNote.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDeliveryNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports